import type { IconData } from '@stacksjs/iconify-core'

export const otherUiWiFi: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 3.35l2 2.913A11 11 0 0 1 8 4.5a11 11 0 0 1 6 1.763l2-2.913A14.66 14.66 0 0 0 8 1c-2.96 0-5.71.866-8 2.35M8 15l-2.286-3.329C6.368 11.247 7.154 11 8 11s1.632.247 2.286.671z\"/><path fill=\"currentColor\" d=\"m13.143 7.51l-2 2.913A5.76 5.76 0 0 0 8 9.5a5.76 5.76 0 0 0-3.143.923l-2-2.912A9.43 9.43 0 0 1 8 6c1.903 0 3.671.556 5.143 1.51\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiWiFi
